import React from 'react';
import styles from './drawerContent.module.scss';
import { CategoryEdge } from '@/apollo/graphql/types/categoryTypes';
import { SearchInput } from '@/components/ui/search-input';
import Link from 'next/link';
import Image from 'next/image';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';
import { config } from '@/apollo/config';
import IconArrowRight from '@/assets/icons/drawer-icons/icon-arrow-right.svg';
import { useTranslations } from 'next-intl';
import RightSectionAds from './rightSectionAds';
import { BannerData } from '@/apollo/graphql/types/bannerTypes';
import { brandListType } from '@/types/headerBottomDriver.type';

const RightSection = ({
  transformedData,
  tab,
  brandList,
  handleRouteByCategory,
  closeButton,
  locale,
  bannerData,
}: {
  transformedData: any;
  tab: string;
  brandList: brandListType[];
  handleRouteByCategory: (edge: CategoryEdge) => void;
  closeButton: () => void;
  locale: string;
  bannerData: BannerData;
}) => {
  const t = useTranslations('General');

  return transformedData.map((category: any) => {
    if (tab === category.id) {
      const popularItems = category.edges.filter(
        (edge: any) => edge.node.isPopular && edge.node.isInCatalog
      );
      const Items = category.edges.filter(
        (edge: CategoryEdge) => !edge.node.isPopular && edge.node.isInCatalog
      );

      return (
        <div className={styles.drawer__rightSection} key={category.id}>
          <div className={styles.drawer__rightSectionContent}>
            <div className={styles.drawer__rightSectionHeader}>
              <div className={styles.drawer__rightSectionInput}>
                <SearchInput />
              </div>
            </div>
            <div className={styles.drawer__rightSectionSubCategories}>
              <h3 className={styles.subTitle}>
                {locale === 'ru' ? category?.name : category?.translation?.name}
              </h3>
              <div className={styles.subCategoriesBrands}>
                {brandList.map((brand: any, i: number) => (
                  <div key={i} className={styles.subCategoriesBrandsBrand}>
                    <div
                    // href={`/brand/${decodeBase64Id(brand.id)}`}
                    >
                      <Image
                        src={`${config.publicApiUrl}${brand.image}`}
                        alt="image-brand-"
                        className={styles.subCategoriesBrandsBrandImg}
                        width={45}
                        height={45}
                      />
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.subCategoriesBrandsLinks}>
                {[0, 1, 2].map(colIndex => (
                  <div
                    key={`col-${colIndex}`}
                    className={styles.subCategoriesBrandsColumn}
                  >
                    {Items.filter(
                      (edge: CategoryEdge, index: number) =>
                        index % 3 === colIndex
                    ).map((edge: CategoryEdge) => (
                      <div
                        key={edge.node.id}
                        className={styles.subCategoriesBrandsSmartphones}
                      >
                        <button onClick={() => handleRouteByCategory(edge)}>
                          {locale === 'ru'
                            ? edge.node.name
                            : edge?.node?.translation?.name}
                        </button>
                        {edge.node.children.edges.map((child: CategoryEdge) => (
                          <Link
                            key={child.node.name}
                            href={`/category/${decodeBase64Id(child.node.id)}-${child.node.slug}`}
                            onClick={closeButton}
                          >
                            {locale === 'ru'
                              ? child.node.name
                              : child?.node?.translation?.name}{' '}
                            <IconArrowRight />
                          </Link>
                        ))}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              {popularItems.length > 0 && (
                <div className={styles.popularCategory}>
                  <h3 className={styles.popularCategoryTitle}>
                    {t('popular-categories')}
                  </h3>
                  <div className={styles.popularItems}>
                    {popularItems.map((edge: CategoryEdge) => (
                      <div className={styles.item} key={edge.node.id}>
                        <div className={styles.ImageCard}>
                          <Image
                            src={`${config.publicApiUrl}${edge?.node.icon}`}
                            alt="image-card"
                            width={51}
                            height={63}
                          />
                        </div>
                        <div className={styles.itemLinks}>
                          <h3>
                            {locale === 'ru'
                              ? edge.node.name
                              : edge?.node?.translation?.name}
                          </h3>
                          {edge.node.children.edges.map(
                            (child: CategoryEdge) => (
                              <Link href="#" key={child.node.id}>
                                {locale === 'ru'
                                  ? child.node.name
                                  : child?.node?.translation?.name}
                              </Link>
                            )
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          <RightSectionAds closeButton={closeButton} bannerData={bannerData} />
        </div>
      );
    }
    return null;
  });
};

export default RightSection;
